import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import './Auth.css';

export default function Register() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");
    setLoading(true);

    // Validointi
    if (password !== confirmPassword) {
      setErrorMsg('Salasanat eivät täsmää');
      setLoading(false);
      return;
    }

    if (!fullName || !email || !password) {
      setErrorMsg('Täytä kaikki pakolliset kentät');
      setLoading(false);
      return;
    }

    if (!supabase) {
      setErrorMsg('Sovellus ei ole konfiguroitu. Tarkista ympäristömuuttujat.');
      setLoading(false);
      return;
    }

    try {
      // Rekisteröi käyttäjä Supabase Authiin
      const redirectTo = `${window.location.origin}/login`;
      const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: redirectTo,
          data: {
            full_name: fullName,
          },
        },
      });

      if (signUpError) {
        console.error('Signup error:', signUpError);
        setErrorMsg(signUpError.message || 'Rekisteröityminen epäonnistui.');
        setLoading(false);
        return;
      }

      // Jos user löytyy heti (email confirmation ei ole pakollinen)
      if (signUpData.user) {
        try {
          // Upsert profiili (ei syntymätietoja vielä)
          const { error: profileError } = await supabase
            .from('profiles')
            .upsert(
              {
                id: signUpData.user.id,
                user_id: signUpData.user.id,
                full_name: fullName,
              },
              { onConflict: 'id' }
            );

          if (profileError) {
            console.error('Profile upsert error:', profileError);
            // Ei heitetä virhettä, profiili luodaan myöhemmin
          }

          // Session tulee heti -> ohjaa welcome-sivulle
          setSuccessMsg("Rekisteröityminen onnistui!");
          setTimeout(() => {
            navigate('/welcome');
          }, 1500);
        } catch (dbError) {
          console.error('Database error:', dbError);
          // Ei heitetä virhettä, profiili luodaan myöhemmin
          setSuccessMsg("Rekisteröityminen onnistui!");
          setTimeout(() => {
            navigate('/welcome');
          }, 1500);
        }
      } else {
        // Email confirmation flow -> ohjaa login-sivulle
        setSuccessMsg("Tarkista sähköposti ja vahvista tili, sitten kirjaudu sisään.");
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      console.error('Register error:', err);
      setErrorMsg('Rekisteröityminen epäonnistui. Yritä uudelleen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Rekisteröidy</h1>
        <p>Aloita astrologinen matkasi</p>

        {errorMsg && <div className="auth-error">{errorMsg}</div>}
        {successMsg && <div className="auth-success">{successMsg}</div>}

        <form onSubmit={handleRegister}>
          <label htmlFor="fullName">Nimi *</label>
          <input
            id="fullName"
            name="fullName"
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Koko nimesi"
            required
          />

          <label htmlFor="email">Sähköposti *</label>
          <input
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sähköposti@esim.fi"
            required
          />

          <label htmlFor="password">Salasana *</label>
          <input
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <label htmlFor="confirmPassword">Vahvista salasana *</label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <button className="auth-button" type="submit" disabled={loading}>
            {loading ? 'Rekisteröidään...' : 'Rekisteröidy'}
          </button>
        </form>

        <p className="auth-footer">
          Onko sinulla jo tili? <Link to="/login">Kirjaudu tästä</Link>
        </p>
      </div>
    </div>
  );
}
